var storefrontApp = angular.module("storefrontApp");

//#region Modal
storefrontApp.directive("modal", [
    "modalService",
    function (modalService) {
        return {
            link: function (scope, element, attrs) {
                if (!attrs.id) return;

                angular.element(document.body).append(element);

                var modal = {
                    id: attrs.id,
                    open: open,
                    close: close,
                };
                modalService.add(modal);

                scope.$on("$destroy", function () {
                    modalService.remove(attrs.id);
                    angular.element(element).remove();
                });

                function open() {
                    element.addClass("d-block");
                    element.removeClass("d-none");
                    angular.element(document.body).addClass("modal-open");
                }

                function close() {
                    element.addClass("d-none");
                    element.removeClass("d-block");
                    angular.element(document.body).removeClass("modal-open");
                }
            },
        };
    },
]);
//#endregion

//#region Ecom Product

//#region Rating

storefrontApp.directive("ecomProductRating", function () {
    return {
        restrict: "A",
        scope: true,
        link: function (scope, element, attrs) {
            scope.ratings = attrs.ratings;
            scope.isProductPage =
                attrs.isProductPage &&
                attrs.isProductPage.toLowerCase() == "true";
            scope.review = attrs.review ? Number(attrs.review) : 0;
            scope.isHalfStar = false;
            if (parseInt(scope.review) != parseFloat(scope.review)) {
                scope.isHalfStar = true;
            }
            scope.getReviewArray = function () {
                return new Array(parseInt(scope.review));
            };
            if (scope.isHalfStar) {
                scope.getEmptyReviewArray = function () {
                    return new Array(5 - parseInt(scope.review) - 1);
                };
            } else {
                scope.getEmptyReviewArray = function () {
                    return new Array(5 - parseInt(scope.review));
                };
            }
        },
        templateUrl: "product_rating.html",
    };
});

//#endregion

//#region Price
storefrontApp.directive("ecomProductPrice", function () {
    return {
        restrict: "A",
        scope: true,
        link: function (scope, element, attrs) {
            scope.salePrice = attrs.saleprice;
            scope.listPrice = attrs.listprice;
        },
        templateUrl: "product_price.html",
    };
});
//#endregion

//#region Image

storefrontApp.directive("ecomProductImage", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                function isKeyDefined(key) {
                    return (
                        angular.isDefined(attrs) &&
                        angular.isDefined(attrs[key])
                    );
                }

                if (angular.isUndefined(scope.prd)) {
                    scope.prd = {};
                }

                if (isKeyDefined("hideQuickView")) {
                    scope.prd.hideQuickView = attrs.hideQuickView;
                }
                if (isKeyDefined("imgUrl")) {
                    scope.prd.imgUrl = attrs.imgUrl;
                } else {
                    scope.prd.url = urlService.getProductUrl({
                        definitionName: scope.prd.definition,
                        catalogId: scope.prd.brand,
                        name: scope.prd.name,
                        sku: scope.prd.productId,
                    });
                    if (
                        angular.isDefined(scope.prd) &&
                        angular.isDefined(scope.prd.productId)
                    ) {
                        scope.prd.imgUrl = urlService.getImageUrl({
                            rgb: scope.rgb,
                            size: attrs.size,
                            sku: scope.prd.productId,
                            catalogId: scope.prd.brand,
                            definitionName: scope.prd.definition,
                            threadConeImageName: scope.isThreadUsed
                                ? scope.threadConeImageName
                                : undefined,
                            showThreadVariants: scope.isThreadUsed
                                ? true
                                : undefined,
                        });
                    }
                }

                scope.showQuickView = function ($event) {
                    $event.preventDefault();
                    if (scope.prd.listPrice > 0) {
                        urlService.trackCustomerViewProduct(
                            scope.prd.productId
                        );
                    }
                    scope.$root.$emit("ShowQuickView", scope.prd.productId);
                };
            },
            templateUrl: "product_image.html",
        };
    },
]);

storefrontApp.directive("ecomListProductImage", [
    function () {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.prd = {};
                scope.prd.name = attrs.name;
                scope.prd.desc = attrs.desc;
                scope.prd.brand = attrs.brand;
                scope.prd.rating = attrs.rating;
                scope.prd.productId = attrs.productId;
                scope.prd.definition = attrs.definition;
                scope.prd.videoParts = attrs.videoParts;
                scope.prd.runTime = attrs.runTime;
                scope.prd.variants =
                    attrs.variants == "" || attrs.variants == undefined
                        ? 0
                        : Number(attrs.variants);
                scope.prd.listPrice =
                    attrs.listPrice == "" || attrs.listPrice == undefined
                        ? null
                        : Number(attrs.listPrice);
                scope.prd.salePrice =
                    attrs.salePrice == "" || attrs.salePrice == undefined
                        ? null
                        : Number(attrs.salePrice);

                scope.prd.isOnSale =
                    scope.prd.saleprice &&
                    scope.prd.saleprice > 0 &&
                    scope.prd.salePrice < scope.prd.listPrice;
                scope.prd.salerank =
                    angular.isDefined(attrs.salerank) && attrs.salerank != ""
                        ? attrs.salerank
                        : 0;
                var topSellerMinRank =
                    window.__env.productTopSellersMinSaleRank;
                if (scope.prd.listPrice && scope.prd.listPrice == 0) {
                    topSellerMinRank =
                        window.__env.freeProductTopSellersMinSaleRank;
                }
                scope.prd.isTopSeller =
                    !scope.prd.isOnSale &&
                    scope.prd.salerank &&
                    Number(scope.prd.salerank) > topSellerMinRank;

                scope.prd.isSewingPattern = attrs.isSewingPattern;
                scope.prd.isHandEmbroidery = attrs.isHandEmbroidery;

                if (angular.isDefined(attrs["hideQuickView"])) {
                    scope.prd.hideQuickView = attrs.hideQuickView;
                }
            },
            templateUrl: "product_lstImage.html",
        };
    },
]);
//#endregion

//#region Product
storefrontApp.directive("ecomProduct", [
    "urlService",
    "configs",
    function (urlService, configs) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.prd = {};
                scope.prd.name = attrs.name;
                scope.prd.desc = attrs.desc;
                scope.prd.brand = attrs.brand;

                function parseListingNumber(val) {
                    if (val == null || val === "") {
                        return null;
                    }
                    if (String(val).indexOf("{{") !== -1) {
                        return null;
                    }
                    var n = Number(val);
                    return isNaN(n) ? null : n;
                }

                function syncListingRatingFromSource() {
                    var src =
                        (scope.item && scope.item._source) ||
                        (scope.data && scope.data._source) ||
                        {};
                    var rating = parseListingNumber(src.rating);
                    if (rating === null) {
                        rating = parseListingNumber(attrs.rating);
                    }
                    if (rating !== null) {
                        scope.prd.rating = rating;
                    }
                    var count = parseListingNumber(src.ratingCount);
                    scope.prd.ratingsCount = count === null ? 0 : count;
                }

                syncListingRatingFromSource();
                attrs.$observe("rating", function (val) {
                    var n = parseListingNumber(val);
                    if (n !== null) {
                        scope.prd.rating = n;
                    }
                });
                attrs.$observe("ratingsCount", function (val) {
                    var n = parseListingNumber(val);
                    if (n !== null) {
                        scope.prd.ratingsCount = n;
                    }
                });
                scope.$watch(
                    function () {
                        return scope.item && scope.item._source
                            ? [
                                  scope.item._source.rating,
                                  scope.item._source.ratingCount,
                              ].join("|")
                            : "";
                    },
                    function () {
                        syncListingRatingFromSource();
                    }
                );

                scope.getListingRating = function () {
                    syncListingRatingFromSource();
                    var n = Number(scope.prd.rating);
                    return isNaN(n) ? 0 : n;
                };
                scope.getListingRatingFill = function () {
                    var r = scope.getListingRating();
                    if (!(r > 0)) {
                        return 0;
                    }
                    return Math.round(r * 2) / 2;
                };
                scope.getListingRatingCount = function () {
                    syncListingRatingFromSource();
                    return Number(scope.prd.ratingsCount) || 0;
                };
                scope.hasListingReviews = function () {
                    return scope.getListingRating() > 0;
                };
                scope.hasListingHalfButterfly = function () {
                    var fill = scope.getListingRatingFill();
                    return fill > 0 && fill % 1 === 0.5;
                };
                function listingFilledArray(count) {
                    var n = Math.max(0, parseInt(count, 10) || 0);
                    var arr = [];
                    for (var i = 0; i < n; i++) {
                        arr.push(i);
                    }
                    return arr;
                }
                scope.getListingFullButterflies = function () {
                    var fill = scope.getListingRatingFill();
                    if (!(fill > 0)) {
                        return [];
                    }
                    return listingFilledArray(Math.floor(fill));
                };
                scope.getListingEmptyButterflies = function () {
                    var fill = scope.getListingRatingFill();
                    if (!(fill > 0)) {
                        return [];
                    }
                    var empty = 5 - Math.ceil(fill);
                    return empty > 0 ? listingFilledArray(empty) : [];
                };

                if (angular.isDefined(attrs["showReviews"])) {
                    scope.prd.showReviews = attrs.showReviews === "true";
                } else {
                    scope.prd.showReviews = false;
                }

                scope.prd.productId = attrs.productId;
                scope.prd.definition = attrs.definition;
                scope.prd.videoParts = attrs.videoParts;
                scope.prd.runTime = attrs.runTime;
                scope.prd.customerInterestIndex = attrs.customerInterestIndex;
                scope.customerInterestIndexThreshold =
                    configs.customerInterestIndexThreshold;
                scope.customerInterestIndexMaxThreshold =
                    configs.customerInterestIndexMaxThreshold;
                scope.prd.variants =
                    attrs.variants == "" || attrs.variants == undefined
                        ? 0
                        : Number(attrs.variants);
                scope.prd.listPrice =
                    attrs.listPrice == "" || attrs.listPrice == undefined
                        ? null
                        : Number(attrs.listPrice);
                scope.prd.salePrice =
                    attrs.salePrice == "" || attrs.salePrice == undefined
                        ? null
                        : Number(attrs.salePrice);

                scope.prd.isOnSale =
                    scope.prd.saleprice &&
                    scope.prd.saleprice > 0 &&
                    scope.prd.salePrice < scope.prd.listPrice;
                scope.prd.salerank =
                    angular.isDefined(attrs.salerank) && attrs.salerank != ""
                        ? attrs.salerank
                        : 0;
                var topSellerMinRank =
                    window.__env.productTopSellersMinSaleRank;
                if (scope.prd.listPrice && scope.prd.listPrice == 0) {
                    topSellerMinRank =
                        window.__env.freeProductTopSellersMinSaleRank;
                }
                scope.prd.isTopSeller =
                    !scope.prd.isOnSale &&
                    scope.prd.salerank &&
                    Number(scope.prd.salerank) > topSellerMinRank;

                scope.prd.isSewingPattern = attrs.isSewingPattern;
                scope.prd.isHandEmbroidery = attrs.isHandEmbroidery;

                if (angular.isDefined(attrs["hideQuickView"])) {
                    scope.prd.hideQuickView = attrs.hideQuickView;
                }

                scope.prd.url = urlService.getProductUrl({
                    definitionName: scope.prd.definition,
                    catalogId: scope.prd.brand,
                    name: scope.prd.name,
                    sku: scope.prd.productId,
                });
                if (attrs.isthreadused && attrs.isthreadused == "true") {
                    scope.rgb = attrs.rgb;
                    scope.colorName = attrs.colorName;
                    scope.threadMfg = attrs.threadMfg;
                    scope.threadtype = attrs.threadtype;
                    scope.threadConeImageName = attrs.threadConeImageName;
                    scope.isThreadUsed =
                        attrs.isthreadused == "true" ? true : false;
                    scope.productUrl = urlService.getProductUrl({
                        definitionName: attrs.definition,
                        catalogId: attrs.catalog,
                        name: attrs.threadtype,
                        sku: scope.id,
                    });
                }
            },
            templateUrl: "product.html",
        };
    },
]);

storefrontApp.directive("ecomProjectTutorial", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.prd = {};
                scope.prd.name = attrs.name;
                scope.prd.author = attrs.author;
                scope.prd.authorId = attrs.authorId;
                scope.prd.type = attrs.type;
                scope.prd.date = attrs.date;
                scope.prd.definition = attrs.definition;
                scope.prd.brand = attrs.brand;
                scope.prd.productId = attrs.productId;
                scope.prd.duration = attrs.duration;
                scope.prd.synopsis = angular.isDefined(attrs.synopsis)
                    ? attrs.synopsis
                    : "";
                if (
                    angular.isDefined(attrs.author) &&
                    angular.isDefined(attrs.authorId) &&
                    attrs.authorId > 0
                ) {
                    scope.prd.authorProjectsUrl =
                        urlService.getAuthorProjectsUrl(
                            attrs.authorId,
                            attrs.author
                        );
                }

                scope.prd.url = urlService.getProductUrl({
                    definitionName: "project_tutorial",
                    name: attrs.name,
                    sku: attrs.productId,
                });
                scope.prd.coverImgUrl = urlService.getImageUrl({
                    definitionName: "project_tutorial",
                    imgName: attrs.imageurl,
                });
            },
            templateUrl: "project_tutorial.html",
        };
    },
]);

storefrontApp.directive("ecomCustomerShowcaseReview", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.customerShowcaseReview = {};
                scope.customerShowcaseReview.imageUrl = attrs.imageUrl;
                scope.customerShowcaseReview.message = attrs.message;
                scope.customerShowcaseReview.productId = attrs.productId;
                scope.customerShowcaseReview.productDefinition =
                    attrs.productDefinition;
                scope.customerShowcaseReview.productName = attrs.productName;
                scope.customerShowcaseReview.productImageUrl =
                    urlService.getImageUrl({
                        catalogId: attrs.vendorName,
                        definitionName: attrs.productDefinition,
                        size: "medium",
                        sku: attrs.productId,
                    });
                scope.customerShowcaseReview.productUrl =
                    urlService.getProductUrl({
                        catalogId: attrs.vendorName,
                        definitionName: attrs.productDefinition,
                        name: attrs.productName,
                        sku: attrs.productId,
                    });
                scope.customerShowcaseReview.rating = attrs.rating;
                scope.customerShowcaseReview.ratingsCount = attrs.ratingsCount;
                scope.customerShowcaseReview.reviewer = attrs.reviewer;
                scope.customerShowcaseReview.vendorName = attrs.vendorName;
            },
            templateUrl: "customer_showcase_review.html",
        };
    },
]);

storefrontApp.directive("ecomLookbook", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.prd = {};
                scope.prd.name = attrs.name;
                scope.prd.type = attrs.type;
                scope.prd.desc = attrs.desc;
                scope.prd.pages = attrs.pages;
                scope.prd.pgImgUrl1 = urlService.getImageUrl({
                    definitionName: "lookbook",
                    lookbookId: attrs.id,
                    pageNumber: 5,
                });
                scope.prd.pgImgUrl2 = urlService.getImageUrl({
                    definitionName: "lookbook",
                    lookbookId: attrs.id,
                    pageNumber: 10,
                });
                scope.prd.coverImgUrl = urlService.getImageUrl({
                    definitionName: "lookbook",
                    lookbookId: attrs.id,
                });
                scope.prd.lookbookUrl = urlService.getProductUrl({
                    definitionName: "lookbook",
                    sku: attrs.id,
                });
            },
            templateUrl: "project_lookbook.html",
        };
    },
]);
//#endregion

//#endregion

//#region Lazyload

storefrontApp.directive("lazyLoad", function () {
    var observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
    };

    function getLazyImageUrl(img) {
        return (
            img.getAttribute("data-src") ||
            img.getAttribute("name") ||
            ""
        ).trim();
    }

    function markImageLoaded(img, host) {
        img.removeAttribute("data-loading");
        img.setAttribute("data-loaded", "true");
        img.classList.remove("lazyload");
        if (host && host.classList) {
            host.classList.remove("shimmer-product");
        }
    }

    function loadImageOnce(img, host) {
        if (
            img.hasAttribute("data-loaded") ||
            img.getAttribute("data-loading") === "true"
        ) {
            return;
        }
        var url = getLazyImageUrl(img);
        if (!url) {
            return;
        }
        if (img.getAttribute("src") === url) {
            if (img.complete && img.naturalWidth > 0) {
                markImageLoaded(img, host);
            }
            return;
        }

        img.setAttribute("data-loading", "true");

        function onLoad() {
            img.removeEventListener("load", onLoad);
            img.removeEventListener("error", onError);
            markImageLoaded(img, host);
        }

        function onError() {
            img.removeEventListener("load", onLoad);
            img.removeEventListener("error", onError);
            markImageLoaded(img, host);
        }

        img.addEventListener("load", onLoad);
        img.addEventListener("error", onError);
        img.setAttribute("src", url);
        if (img.complete) {
            if (img.naturalWidth > 0) {
                onLoad();
            } else {
                onError();
            }
        }
    }

    function loadImagesInHost(host) {
        var imgs = host.querySelectorAll("img");
        angular.forEach(imgs, function (img) {
            loadImageOnce(img, host);
        });
    }

    return {
        restrict: "A",
        link: function (scope, element) {
            var host = element[0];
            if (!host || !(host instanceof HTMLElement)) {
                console.error(
                    "Invalid parent element for lazyLoad directive:",
                    host
                );
                return;
            }

            var intersectionObserver = null;
            var triggered = false;

            function onIntersect(entries) {
                entries.forEach(function (entry) {
                    if (!entry.isIntersecting || triggered) {
                        return;
                    }
                    triggered = true;
                    loadImagesInHost(host);
                    if (intersectionObserver) {
                        intersectionObserver.unobserve(host);
                        intersectionObserver.disconnect();
                        intersectionObserver = null;
                    }
                });
            }

            if (typeof IntersectionObserver === "undefined") {
                loadImagesInHost(host);
                return;
            }

            intersectionObserver = new IntersectionObserver(
                onIntersect,
                observerOptions
            );
            intersectionObserver.observe(host);

            scope.$on("$destroy", function () {
                if (intersectionObserver) {
                    intersectionObserver.disconnect();
                    intersectionObserver = null;
                }
            });
        },
    };
});

//#endregion

//#region File Upload
storefrontApp.directive("fileUpload", [
    "$parse",
    "$timeout",
    "loaderService",
    function ($parse, $timeout, loaderService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileUpload);
                var modelSetter = model.assign;
                element.bind("change", function () {
                    loaderService.show();
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files[0]);
                        $timeout(function () {
                            loaderService.hide();
                        }, 1000);
                    });
                });
            },
        };
    },
]);
//#endregion

//#region Files Upload
storefrontApp.directive("filesUpload", [
    "$parse",
    function ($parse) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                var model = $parse(attrs.filesUpload);
                var modelSetter = model.assign;
                element.bind("change", function () {
                    scope.$apply(function () {
                        modelSetter(scope, element[0].files);
                    });
                });
            },
        };
    },
]);
//#endregion

// #region CKEditor
storefrontApp.directive("ckeditor", function () {
    return {
        require: "?ngModel",
        link: function (scope, element, attr, ngModel) {
            //COMPUTE id attribute
            if (attr.key) {
                var keyValue = scope.$eval(attr.key);
                element[0].id += "_" + keyValue;
            }
            var ck = CKEDITOR.replace(element[0]);
            if (!ngModel) return;
            ck.on("pasteState", function () {
                scope.$apply(function () {
                    ngModel.$setViewValue(ck.getData());
                });
            });
            ngModel.$render = function (value) {
                ck.setData(ngModel.$viewValue);
            };
        },
    };
});
//#endregion

//#region Share Link
storefrontApp.directive("ecomSharelink", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.prodId = attrs.name;
                scope.catalog = attrs.catalog;
                scope.type = attrs.type;
                scope.rgb = attrs.rgb;
                scope.cone = attrs.cone;
                scope.projectImg = attrs.project;
                scope.saleUrl = attrs.sale;

                var prod = {};
                prod.definitionName = scope.type;
                prod.catalogId = scope.catalog;
                prod.sku = scope.prodId;
                prod.rgb = scope.rgb;
                prod.threadConeImageName = scope.cone;

                var imgUrl = "";

                if (scope.projectImg != null && scope.projectImg != "") {
                    imgUrl = scope.projectImg;
                } else {
                    imgUrl = urlService.getImageUrl(prod);
                }

                if (scope.saleUrl != null && scope.saleUrl != "") {
                    scope.facebook =
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        scope.saleUrl;
                    scope.pintrest =
                        "http://pinterest.com/pin/create/button/?url=" +
                        scope.saleUrl +
                        "&media=" +
                        imgUrl;
                } else {
                    scope.facebook =
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        window.location.href;
                    scope.pintrest =
                        "http://pinterest.com/pin/create/button/?url=" +
                        window.location.href +
                        "&media=" +
                        imgUrl;
                }
            },
            templateUrl: "share_link.html",
        };
    },
]);
//#endregion

storefrontApp.directive("ecomLearningcenterProductvideosTutorial", [
    "urlService",
    function (urlService) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                scope.lcproductvideostutorial = {};
                scope.lcproductvideostutorial.imageUrl = attrs.imageUrl;
                scope.lcproductvideostutorial.videoTitle = attrs.videoTitle;
                scope.lcproductvideostutorial.itemId = attrs.itemId;
                scope.lcproductvideostutorial.vendorName = attrs.vendorName;
                scope.lcproductvideostutorial.videoUrl = attrs.videoUrl;
            },
            templateUrl: "learningcenter_productvideos_tutorial.html",
        };
    },
]);

storefrontApp.directive("phoneNumberFormatter", function ($filter) {
    return {
        require: "ngModel",
        link: function (scope, element, attrs, ngModelCtrl) {
            // Function to format and update the model value
            function formatAndUpdateModel(value) {
                if (value == undefined || value == null) {
                    return "";
                }
                var modelValue = value.replace(/[^0-9]/g, "");
                var formattedValue = $filter("phoneNumberFormatter")(
                    modelValue.toString()
                );

                ngModelCtrl.$setViewValue(formattedValue);
                ngModelCtrl.$render();
                return modelValue;
            }

            // Apply formatting when model value changes
            ngModelCtrl.$parsers.push(function (value) {
                return formatAndUpdateModel(value);
            });

            // Apply formatting on initial load
            scope.$watch(attrs.ngModel, function (value) {
                formatAndUpdateModel(value);
            });

            // Handle key events to skip non-digit keys
            element.bind("keypress", function (event) {
                if (event.which < 48 || event.which > 57) {
                    event.preventDefault();
                }
            });
        },
    };
});
